import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "transparent",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.667 8a5.333 5.333 0 1 1 10.666 0A5.333 5.333 0 0 1 2.667 8M8 1.333a6.667 6.667 0 1 0 0 13.333A6.667 6.667 0 0 0 8 1.333m-.747 9.603c0 .369.299.667.667.667h.087a.667.667 0 0 0 .666-.667V7.15a.667.667 0 0 0-.666-.667H7.92a.667.667 0 0 0-.667.667zm.17-5.323q.227.21.544.21a.76.76 0 0 0 .54-.21.68.68 0 0 0 .226-.51.66.66 0 0 0-.226-.503.75.75 0 0 0-.54-.214.77.77 0 0 0-.544.214.67.67 0 0 0-.223.503.68.68 0 0 0 .223.51",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }